import { createFileRoute } from '@tanstack/react-router'

import { useBuscaMergeguard } from '@/features/mergeguard/busca-rota'
import {
  type BuscaMergeguard,
  buscaParaParametros,
  lerBuscaMergeguard,
} from '@/features/mergeguard/filtros'
import { PaginaMergeguard } from '@/features/mergeguard/pagina'

export const Route = createFileRoute('/$perfil/mergeguard/')({
  validateSearch: (busca: Record<string, unknown>): BuscaMergeguard => lerBuscaMergeguard(busca),
  search: {
    // Antes de gravar o endereço: id só de dígitos vai como número, para sair
    // `?projeto=42` e não `?projeto=%2242%22`. Na leitura volta a ser texto.
    middlewares: [
      ({ search, next }) => buscaParaParametros(next(search)) as unknown as BuscaMergeguard,
    ],
  },
  component: Tela,
})

function Tela() {
  // Só as chaves validadas chegam à página (ver `useBuscaMergeguard`).
  const { busca, aoMudarBusca } = useBuscaMergeguard()
  return <PaginaMergeguard busca={busca} aoMudarBusca={aoMudarBusca} />
}
